import { createFileRoute } from '@tanstack/react-router'

import { ContractsPageSkeleton } from '#/modules/contract/front-office/contracts-page/contracts-page-skeleton.tsx'
import { ContractsPage } from '#/modules/contract/front-office/contracts-page/contracts-page.tsx'
import { FRONT_OFFICE_V2_QUERY_OPTIONS } from '#/shared/front-office-v2-query-options.ts'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/(customer)/_shell/contracts-v2/')({
  beforeLoad: ({ context }) => requirePermissions(context, ['contract.read']),
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData(
        context.trpc.contracts.listMyContracts.queryOptions(undefined, FRONT_OFFICE_V2_QUERY_OPTIONS),
      ),
      context.queryClient.ensureQueryData(
        context.trpc.subscriptions.listMyUnsignedSubscriptions.queryOptions(
          { isArchived: false },
          FRONT_OFFICE_V2_QUERY_OPTIONS,
        ),
      ),
    ]),
  pendingComponent: ContractsPageSkeleton,
  pendingMs: 150,
  component: ContractsPage,
})
